import useFetch from '@hooks/useFetch';
import { emptyList } from '@constants/empty';

export const getKey = (courseUID) =>
  `v1/collection/${courseUID}/relevant_courses/`;

const useRelevantFreeCourses = (
  courseUID,
  options = {
    revalidateOnMount: false,
    selector: null,
    fallbackData: undefined
  }
) => {
  const key = getKey(courseUID);

  const {
    data: relevantFreeCourses,
    isValidating,
    ...rest
  } = useFetch(
    key,
    {},
    {
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  if (options.selector && typeof options.selector === 'function') {
    return options.selector(relevantFreeCourses || emptyList);
  }

  return {
    key,
    relevantFreeCourses: relevantFreeCourses || emptyList,
    isValidating,
    ...rest
  };
};

export default useRelevantFreeCourses;
